export default __webpack_public_path__ + "static/media/close-circle.e8b8d7eb.svg";